
import { Tabs } from 'antd';
import React from 'react';
import styles from './bulk-processing.module.scss';
import BulkDownloadTalentProfile from './BulkDownloadTalentProfile/BulkDownloadTalentProfile';
import { BreadCrumb } from '../../../components';
import { getBreadCrumbList } from '../../../utils/helper';
import GlobalAlertMessage from '../../../components/GlobalAlertMessage/GlobalAlertMessage';
import { PERMISSION } from '../../../utils/constants';

const tabs = [
    { key: 0, label: 'Bulk Download Talent Profile', path: 'bulk-download-tp', permission: PERMISSION.BULK_DOWNLOAD_TALENT_PROFILE },
];

export default function BulkProcessing() {
    const onChangeTab = () => {
    };
    return (
        <div className="max-width">
            <div className={styles.pageContainer}>
                <div>
                    <BreadCrumb level={3} breadCrumbList={getBreadCrumbList([`Dashboard`, `Admin`, `Bulk Processing`])} />
                    <GlobalAlertMessage />
                </div>
                <h3 className={styles.mainTitle}>Bulk Processing</h3>
                <Tabs defaultActiveKey="0" activeKey={0} onChange={onChangeTab} items={tabs} />

                <BulkDownloadTalentProfile />
            </div>
        </div>
    );
}